import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  display: false,
  topicName: '',
  fields: [],
};

function setFieldsDetail(fieldPrefix, fieldsDetial) {
  const fields = fieldsDetial.map((field, index) => {
    const fieldType = `${field.type || 'unnamed-type'}`;
    const fieldId = field.id || `${fieldType}-${fieldPrefix}-${index + 1}`;

    const fieldInfo = {
      id: fieldId,
      type: field.type,
      label: field.default_text,
      name: field.default_text || field.type,
      isRequired: (field.required),
      value: '',
      hasError: (field.required),
    };

    if (field.character_limit) {
      fieldInfo.limit = field.character_limit;
    }

    if (field.options) {
      fieldInfo.options = field.options.map(value => ({
        value,
        label: value,
      }));
    }

    if (field.link_src) {
      fieldInfo.href = field.link_src;
    }

    if (field.title) {
      fieldInfo.title = field.title;
    }

    return fieldInfo;
  });
  return fields;
}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_TOPIC_DATA:
      return Object.assign({}, state, { isLoading: true });
    case types.RECEIVE_TOPIC_DATA_ERROR:
    case types.RECEIVE_EMPTY_FIELDS_NO_INTENT:
      return Object.assign({}, state, { isLoading: false, error: false, display: false });
    case types.RECEIVE_EMAIL_ERROR_NO_INTENT:
      return Object.assign({}, state, { isLoading: false, error: true, display: false });
    case types.SELECT_RESULT:
      return Object.assign({}, state, {
        topicName: action.payload.topicName,
        subTopicName: action.payload.topicName,
        fieldPrefix: action.payload.topicId,
        fields: [],
      });
    case types.RECEIVE_FORM_FIELDS_NO_INTENT:
      return Object.assign({}, state, {
        isLoading: false,
        kanaCode: action.payload.kanaCode,
        fields: setFieldsDetail(state.fieldPrefix, action.payload.formFields),
        error: false,
        display: false,
        topicRefId: action.payload.topicRefId,
      });
    case types.REQUEST_BY_EMAIL_NO_INTENT:
      return Object.assign({}, state, { display: true });
    case types.PRESERVE_FIELD_DATA_NO_INTENT:
      return Object.assign({}, state, { fields: action.payload });
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
    case types.RECEIVE_EMAIL_RESPONSE_NO_INTENT:
    case types.LOGIN_EMAIL_NO_INTENT :
      return Object.assign({}, state, { display: false });
    default:
      return state;
  }
}
